import { authAxios } from "./createAxios";

export const postHandleSubmit = async (url) => {
  try {
    const res = await authAxios.post(url);
    return res;
  } catch (err) {
    throw err;
  }
};
